<script setup lang="ts">
import { analytics } from '@/scitylana';

import TruButton from '../TruButton.vue';
import TruCard from '../TruCard.vue';

function gotoMightyVet() {
    analytics.home.mightyVet();

    window.open('https://mightyvet.org');
}

function screenWidthTabletOrBelow() {
    return screen.width < 1300;
}
</script>

<template>
    <div class="mighty-vet">
        <TruCard>
            <div class="flex flex-nowrap">
                <div
                    class="left flex flex-col"
                    :class="{ 'mr-21': !screenWidthTabletOrBelow }"
                >
                    <img
                        class="w-45 mb-6"
                        src="../../assets/images/mighty-vet.png"
                        :alt="$t('dashboard.mightyVet.altText')"
                    >

                    <div class="desk-body-reg mb-6">
                        {{ $t('dashboard.mightyVet.body') }}
                    </div>

                    <TruButton
                        class="fit-content"
                        secondary
                        size="xs"
                        @click="gotoMightyVet"
                    >
                        {{ $t('dashboard.mightyVet.button') }}
                    </TruButton>
                </div>

                <img
                    class="self-center"
                    src="../../assets/images/mighty-vet-logo.png"
                    :alt="$t('dashboard.mightyVet.altTextLogo')"
                >
            </div>
        </TruCard>
    </div>
</template>
